/* istanbul ignore file */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import Card from 'react-bootstrap/Card';
import PropTypes from 'prop-types';

const CardHeader = ({
  sensorName, typeName, macAddress, onSettingsClick, lastUpdated, isMuted,
}) => (
  <Card.Header style={{
    backgroundColor: '#fff',
    borderRadius: '10px 10px 0 0',
    color: '#000',
    padding: '0.25rem 0.5rem',
    paddingBottom: '0px',
  }}
  >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <h5
        style={{
          margin: 0,
          flex: '1',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          paddingRight: '8px',
        }}
        title={sensorName}
      >
        {sensorName}
      </h5>
      <FontAwesomeIcon
        icon={faCog}
        style={{ color: 'gray', cursor: 'pointer', flexShrink: 0 }}
        onClick={onSettingsClick}
      />
    </div>
    <div style={{ color: '#a9a9a9', lineHeight: '14px' }}><small>{typeName}</small></div>
    <div style={{ color: '#a9a9a9', lineHeight: '18px' }}><small>{macAddress}</small></div>
    <div style={{ color: '#a9a9a9', lineHeight: '18px' }}>
      <small style={{ isolation: 'isolate' }}>
        {lastUpdated}
        {isMuted && <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: '#f38125' }} className="ml-1" />}
      </small>
    </div>
  </Card.Header>
);

CardHeader.defaultProps = {
  isMuted: false,
};
CardHeader.propTypes = {
  sensorName: PropTypes.string.isRequired,
  typeName: PropTypes.string.isRequired,
  macAddress: PropTypes.string.isRequired,
  onSettingsClick: PropTypes.func.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  isMuted: PropTypes.bool,
};

export default CardHeader;
